/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseselectacategory3Inputs */

const en_pleaseselectacategory3 = /** @type {(inputs: Pleaseselectacategory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a category`)
};

const de_pleaseselectacategory3 = /** @type {(inputs: Pleaseselectacategory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wähl eine Kategorie`)
};

/**
* | output |
* | --- |
* | "Please select a category" |
*
* @param {Pleaseselectacategory3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseselectacategory3 = /** @type {((inputs?: Pleaseselectacategory3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseselectacategory3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseselectacategory3(inputs)
	return de_pleaseselectacategory3(inputs)
});
export { pleaseselectacategory3 as "pleaseSelectACategory" }